// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2zS-R","question":"Question_question__26oPb","description":"Question_description__WHLx-"};